import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'
import { BiddingIntradayOrderOrderMethod } from '@ebalance/proto/bffuser/v1/bidding_intraday_model_pb'
import type { TFunction } from 'i18next'

import { convertAreaLabel } from '~/models/area'

/** 札の概要に出す札の値。 価格・量は素の文字列 (量は MW)。 */
export type WithdrawSummaryOrder = {
  timeCode: number
  areaCode: AreaCode
  direction: Side
  orderMethod?: BiddingIntradayOrderOrderMethod
  priceYenPerKwh?: string
  volumeMw?: string
}

/**
 * 札の概要の文言に差し込む値 (コマ / エリア / 売買 / 価格 / 量)。 予約取消の確認 (本文が概要を
 * 含む 1 つの文言) も同じ値を使う。
 */
export function withdrawSummaryParams(
  t: TFunction,
  order: WithdrawSummaryOrder,
): { koma: number; area: string; side: string; price: string; volume: number } {
  return {
    koma: order.timeCode,
    area: convertAreaLabel(order.areaCode),
    side: t(
      order.direction === Side.BUY
        ? 'page:biddingSpot.side.buy'
        : 'page:biddingSpot.side.sell',
    ),
    price: Number(order.priceYenPerKwh ?? '0').toFixed(2),
    volume: Number(order.volumeMw ?? '0'),
  }
}

/** 失敗トースト・成功トースト・取消確認の札の概要 (コマ / エリア / 売買 / 価格 × MW)。 */
export function formatWithdrawSummary(
  t: TFunction,
  order: WithdrawSummaryOrder,
): string {
  const params = withdrawSummaryParams(t, order)
  return order.orderMethod === BiddingIntradayOrderOrderMethod.MARKET
    ? t('page:biddingIntraday.withdrawFailedToast.summaryMarket', params)
    : t('page:biddingIntraday.withdrawFailedToast.summary', params)
}
